<template>
    <div class="services-detail-page">
        <layouts-header></layouts-header>

        <breadcrumb :title="title" :text="text" :text1="text1" />

        <!-- Page Content -->
        <div class="content">
            <div class="container">
                <div class="service-detail">
                    <div class="banner">
                        <img src="@/assets/img/services/service-11.jpg" class="img-fluid" alt="Service">
                    </div>
                    <h2>Sports Performance Training</h2>
                    <p class="mb-0">DreamSports offers tailored sports performance training programs designed to enhance
                        your
                        athletic performance in badminton. Improve your physical conditioning, agility, speed, and strength
                        through targeted exercises and specialized training techniques. </p>
                    <div class="dull-bg text-center">
                        <p class="mb-0">typesetting industry. Lorem Ipsum has been the ndustry standard dummy text ever
                            since
                            the 1500s, when an unknown printer took a galley of type and scrambled it to make a type
                            specimen
                            book.</p>
                    </div>
                    <div class="our-benefits">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="banner">
                                    <img src="@/assets/img/services/service-12.jpg" class="img-fluid" alt="Service">
                                </div>
                            </div>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="info">
                                    <h3>Our Benefits</h3>
                                    <p>Our experienced trainers will help you develop the necessary attributes to excel on
                                        the
                                        badminton court.</p>
                                    <ul>
                                        <li><i class="fa-solid fa-bolt"></i> <span>Tailored sports performance training
                                                enhances
                                                endurance, agility, and flexibility.</span></li>
                                        <li><i class="fa-solid fa-bolt"></i> <span>Improve footwork, reaction time, and
                                                court
                                                maneuverability.</span>
                                        </li>
                                        <li><i class="fa-solid fa-bolt"></i> <span>Develop strength and power for stronger,
                                                precise shots.</span></li>
                                        <li><i class="fa-solid fa-bolt"></i> <span>Knowledgeable trainers guide proper
                                                technique
                                                and progression.</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>Boost physical capabilities, gain confidence, and a competitive edge through our inclusive sports
                        performance training programs. Suitable for all levels, from beginners to advanced players seeking
                        peak
                        performance in badminton.</p>
                </div>
                <div class="pagination d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="prev d-flex justify-content-center align-items-center"><i
                                class="feather-arrow-left"></i>
                        </div>
                        <a href="javascript:void(0);" class="info text-left d-none d-sm-none d-md-block">
                            <h4>Previous</h4>
                            <p>Alteration in some form by injected<br>humour or randomised</p>
                        </a>
                    </div>
                    <div class="icon">
                        <router-link to="/pages/services"><img src="@/assets/img/icons/detail-pagination.svg"
                                class="img-fluid" alt="Icon"></router-link>
                    </div>
                    <div class="d-flex align-items-center">
                        <a href="javascript:void(0);" class="info text-right d-none d-sm-none d-md-block">
                            <h4>Next</h4>
                            <p>Alteration in some form by injected<br>humour or randomised</p>
                        </a>
                        <div class="next d-flex justify-content-center align-items-center"><i
                                class="feather-arrow-right"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <layout-footer></layout-footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            title: "Service Detail",
            text: "Home",
            text1: "Service Detail",
        };
    },
};
</script>